<script setup>
import { defineProps, computed} from "vue";
import LinhaDePagamentosDeAprovarContasAPagar from "./LinhaDePagamentosDeAprovarContasAPagar.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
]);

//==================================================================//
//============= Pagamentos de Contas a Pagar Headers ===============//
//==================================================================//

let pagamentosHeaders = [
    { text: 'Seq do Pagamento',         value: 'sequencia'},
    { text: 'Status',                   value: 'status'},
    { text: 'Nota Fiscal Recebida',     value: 'notaFiscalRecebidaNumero'},
    { text: 'Data Criação',             value: 'dataCriacao'},
    { text: 'Data Vencimento',          value: 'dataVencimento'},
    { text: 'Valor Desconto',           value: 'valorDesconto'},
    { text: 'Valor Pagamento',          value: 'valorPagamento'},
    { text: 'Valor Reservado',          value: 'valorReservado'},
    { text: 'Valor a Pagar',            value: 'valorParaPagar'},
    { text: 'Valor Pago',               value: 'valorPago'},
    { text: 'Valor a Vincular',         value: 'valorParaVincular'},
    { text: 'Valor Vinculado',          value: 'valorVinculado'},
    { text: '',                         value: 'espaco'},
]

//==================================================================//
//======================= Mostra Pagamentos ========================//
//==================================================================//

let mostraPagamentos = computed(()=>{

    if(props?.contaAPagar?.pagamentosQuantidade <= 0){
        return false;
    }

    if(props?.dado?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row"
        v-show="mostraPagamentos"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <div class="c-table-wrapper">

                    <div class="c-table">

                        <div class="c-table__headers">

                            <div class="c-table__header" v-for="pagamentoHeader in pagamentosHeaders"
                                :key="pagamentoHeader.value"
                            >

                                <div class="c-table__header-content">

                                    {{pagamentoHeader.text}}

                                </div>
                                
                            </div>

                        </div>
                        <div class="c-table__body">

                            <LinhaDePagamentosDeAprovarContasAPagar v-for="pagamento in props?.contaAPagar?.pagamentos"
                                :controlesDesativados="props?.controlesDesativados"
                                :key="pagamento.id"
                                :dado="props?.dado"
                                :contaAPagar="props?.contaAPagar"
                                :pagamento="pagamento"
                            ></LinhaDePagamentosDeAprovarContasAPagar>

                        </div>

                    </div>

                </div>
                
            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: grid;
    grid-column: 1 / -1;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table-wrapper{
    overflow: hidden !important;
    padding: 12px 12px 12px 266px !important;
}

.c-table{
    background: #ffffff;
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

.c-table__headers{
    display: contents;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-table__header{
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #dedede;
    color: #363636;
}

.c-table__body{
    display: contents;
}

</style>
